export default {
    path: 'menu',
    name: 'MenuList',
    component: () => import(/* webpackChunkName: "menu-list" */ '@/pages/menu/MenuList'),
    meta: { title: '菜单管理' }
}
